module.exports = __webpack_public_path__ + "static/media/(000095).944d3f8d.jpg";